import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from 'react';
import { useCurrentEffect } from '../../../../../../lib/use-current-effect';

import { usePatient } from '../../../../../../hooks/patient';
import { getMeasurementsByDay } from '../../../../../../services/metrics';

import Img from '../../../../../../assets/images/passos.svg';
import MeasurementsArea from '../../MeasurementsArea';

import { ChildrenProps, ChildrenRefProps } from '../..';
import { MetricTypeEnum } from '../../../../../../enums/MetricTypeEnum';

const StepChart: React.ForwardRefRenderFunction<
  ChildrenRefProps,
  ChildrenProps
> = ({ dateFilter }, ref) => {
  const { patient } = usePatient();

  const [data, setData] = useState<string | number>();
  const [isLoading, setIsLoading] = useState(true);

  const handleChange = useCallback(
    async (patientId?: string, isCurrent = () => true) => {
      setIsLoading(true);
      if (!patientId) {
        return;
      }

      const response = await getMeasurementsByDay({
        patientId,
        metricType: MetricTypeEnum.STEPS,
        dateFilter,
      });

      if (response.length > 0) {
        // A rota do dia vem em ordem crescente e o contador é acumulado: o total do
        // dia é a ÚLTIMA leitura. O `find` de antes pegava a primeira (o acumulado
        // da manhã).
        const withValue = response.filter(
          (item) => typeof item.steps === 'number',
        );
        const value = withValue[withValue.length - 1]?.steps.toString();

        if (isCurrent()) {
          setData(value);
        }
      } else if (isCurrent()) {
        setData(undefined);
      }

      setIsLoading(false);
    },
    [dateFilter],
  );

  useCurrentEffect(
    (isCurrent) => {
      (() => {
        if (patient?.id) {
          handleChange(patient.id, isCurrent);
        } else {
          setIsLoading(false);
        }
      })();
    },
    [dateFilter, handleChange, patient],
  );

  useImperativeHandle(ref, () => ({
    reload: () => handleChange(patient?.id),
  }));

  return (
    <MeasurementsArea
      data={{
        isLoading,
        styleData: 'info',
        dataDetails: data,
      }}
    >
      <img src={Img} alt="icone de passos" />

      <div>
        <span>Hoje o paciente deu</span>

        <h1>{data}</h1>

        <span>passos</span>
      </div>
    </MeasurementsArea>
  );
};

export default forwardRef(StepChart);
